
export default class ProgressBar {
  constructor() {
    this.progressTrigger = document.querySelector('.js-progress-trigger');
    this.progressBar = document.querySelector('.js-progress-bar');

    if (this.progressTrigger && this.progressBar) {
    this.init();
    } else {
      return;
    }
  }

  init(){
      this.progressTrigger.addEventListener('scroll', () => {
        const scrollLeft = this.progressTrigger.scrollLeft;
        const maxScrollLeft = this.progressTrigger.scrollWidth - this.progressTrigger.clientWidth;
        const scrollPercent = (scrollLeft / maxScrollLeft) * 100;

        this.progressBar.style.transform = `translateX(${scrollPercent}%)`;
      });
  }

}